export const FormsActionsEnum = {
  Edit: {
    key: 1,
    value: 'edit',
  },
  View: {
    key: 2,
    value: 'view',
  },
  Reject: {
    key: 3,
    value: 'reject',
  },
  WithdrawToEdit: {
    key: 4,
    updateFormStatus: 5,
    value: 'withdraw-to-edit',
  },
  RevokeToEdit: {
    key: 5,
    updateFormStatus: 6,
    value: 'revoke-to-edit',
  },
  NotSharableEdit: {
    key: 6,
    isForNotSharableOnly: true,
    value: 'edit',
  },
  Remind: {
    key: 7,
    value: 'remind',
  },
};
